import bannerImg from './banners/woman-helping-man-gym.jpg';


const satisfacao = (t) => ({
    id: 'satisfacao',
    title: t('templates.items.satisfacao.title'),
    description: t('templates.items.satisfacao.description'),
    indicatedFor: t('templates.audiences.contentCreators'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.satisfacao.summary.satisfactionLevel'),
        t('templates.items.satisfacao.summary.likedMost'),
        t('templates.items.satisfacao.summary.improve'),
        t('templates.items.satisfacao.summary.wouldRecommend'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.satisfacao.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.satisfacao.form.experience.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.satisfacao.form.experience.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.satisfacao.form.experience.overallSatisfaction.label'),
                        description: null,
                        required: true,
                        settings: {
                            max: 5,
                            min: 1,
                            maxLabel: t('templates.items.satisfacao.form.experience.overallSatisfaction.maxLabel'),
                            minLabel: t('templates.items.satisfacao.form.experience.overallSatisfaction.minLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.satisfacao.form.experience.likedMost.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.satisfacao.form.experience.improve.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'yes_no_maybe',
                        label: t('templates.items.satisfacao.form.experience.recommend.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default satisfacao;
